//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BackendServices from '@/services/backend-services.js';
import { required } from "@/utils/validations.js";
import { noValidation } from "@/utils/validations.js";

export default {
  name: "geographyTab",
  props: ["value"],
  components: {},
  mounted: function() {
    this.loadGeoLists()
  },
  data: () => ({
    validForm: false,
    tab: "traits",
    districtList: [],
    countyList: [],
    borroughList: []
  }),
  methods: {
    required,
    noValidation,
    updateData() {
      this.$emit("value", this.value);
    },
    clearDistrictChildren() {
      this.value.geography[1].id = null;
      this.clearCountyChildren();
      this.loadGeoLists();
      this.updateData()
    },
    clearCountyChildren() {
      this.value.least_geo_level_id = null;
      this.loadGeoLists();
      this.updateData()
    },
    validateData: function() {
      this.$refs.form.validate().then(success => {
        if (success) {
          this.validForm = true;
          this.$emit("form-valid", this.validForm);
        } else {
          this.validForm = false;
          this.$emit("form-invalid", this.validForm);
        }
      });
    },
    loadGeoLists() {
      BackendServices.getDistricts().then((response) => {
        this.districtList = response.data
      })
      BackendServices.getCountiesByDistrict(this.value.geography[0].id).then((response) => {
        this.countyList = response.data
      })
      BackendServices.getBorroughsByCounty(this.value.geography[1].id).then((response) => {
        this.borroughList = response.data
      })
    }
  },
  watch: {
    value: function(newValue) {
      this.value = newValue;
    }
  }
};
